import React, { useState } from 'react';
import './SearchBar.css';

function SearchBar({ tickets }) {
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleClearSearch = () => {
    setSearchTerm('');
  };

  const handleResultClick = (ticket) => {
    const element = document.getElementById(`ticket-${ticket.issue_key}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      element.classList.add('highlight');
      setTimeout(() => {
        element.classList.remove('highlight');
      }, 2000);
    }
  };

  const getHighlightedText = (text) => {
    if (!searchTerm) return text;
    const regex = new RegExp(`(${searchTerm})`, 'gi');
    return text.replace(regex, (match) => `<mark>${match}</mark>`);
  };

  const filteredTickets = tickets.filter((ticket) => {
    const searchLower = searchTerm.toLowerCase();
    return (
      ticket.issue_key?.toLowerCase().includes(searchLower) ||
      ticket.summary?.toLowerCase().includes(searchLower) ||
      ticket.description?.toLowerCase().includes(searchLower) ||
      ticket.category?.toLowerCase().includes(searchLower) || // ✅ NEW SEARCH FIELD
      (ticket.initial_effort_estimations && ticket.initial_effort_estimations.toString().includes(searchTerm)) // ✅ NEW SEARCH FIELD
    );
  });

  const getTicketPreview = (ticket) => {
    let preview = `<strong>${getHighlightedText(ticket.issue_key)}</strong>: ${getHighlightedText(ticket.summary || '')}`;
    
    // Add category to preview if it exists and matches search
    if (ticket.category && ticket.category.toLowerCase().includes(searchTerm.toLowerCase())) {
      preview += ` <span style="color: #6f42c1; font-weight: 600;">[${getHighlightedText(ticket.category)}]</span>`;
    }
    
    // Add effort estimation to preview if it exists and matches search
    if (ticket.initial_effort_estimations && ticket.initial_effort_estimations.toString().includes(searchTerm)) {
      preview += ` <span style="color: #28a745; font-weight: 600;">(${getHighlightedText(ticket.initial_effort_estimations.toString())} days)</span>`;
    }
    
    return preview;
  };

  return (
    <div className="search-bar">
      <div className="search-input-wrapper">
        <input
          type="text"
          placeholder="Search tickets, categories, effort..."
          value={searchTerm}
          onChange={handleSearchChange}
        />
        {searchTerm && (
          <button className="clear-button" onClick={handleClearSearch}>✖</button>
        )}
      </div>
      {searchTerm && (
        <div className="search-results">
          {filteredTickets.length > 0 ? (
            filteredTickets.map((ticket) => (
              <div
                key={ticket.issue_key}
                className="search-result"
                onClick={() => handleResultClick(ticket)}
                dangerouslySetInnerHTML={{
                  __html: getTicketPreview(ticket)
                }}
              />
            ))
          ) : (
            <div className="no-results">No tickets match your search.</div>
          )}
        </div>
      )}
    </div>
  );
}

export default SearchBar;